import * as THREE from 'three';

export class Portal {
    constructor({ id, config, assets, libraryModel }) {
        const { name, model, portalIndex, className, audioData } = config;

        this._id = id;
        this._portalIndex = portalIndex;
        this._audioData = audioData;

        // World associated with this portal
        this._world = new className({
            name,
            model: model || `${name}Model`, // fallback to eg. hiddenWolfModel
            assets,
        });

        // Create Three objects from the main library model
        this._object3d = libraryModel.scene.getObjectByName(`portal${id}`);
        this._collidable = libraryModel.scene.getObjectByName(`collidable${id}`);
        this._collidable.visible = false;

        const dirPortal = new THREE.Vector3();
        this._collidable.getWorldDirection(dirPortal);
        this._collidable.worldDirection = dirPortal;

        // World start / World end
        this._worldStart = libraryModel.scene.getObjectByName(`w${id}s`);
        this._worldEnd = libraryModel.scene.getObjectByName(`w${id}e`);

        // Set these transforms in the world
        this._world.setPortalTransforms(this._worldStart, this._worldEnd);

        // Apply the material from the World to the 3D object
        this._object3d.material = new THREE.MeshBasicMaterial({
            map: this._world.renderTarget.texture,
        });
    }

    takeScreenshot({ renderer }) {
        // console.log("Attempting screenshot", this._world, this.toString());
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.setRenderTarget(this._world.renderTarget);
        renderer.render(this._world.scene, this._world.camera);
        renderer.setRenderTarget(currentRenderTarget);

        return this._world.renderTarget.texture;
    }

    get portal3d() {
        return this._object3d;
    }

    get collidable() {
        return this._collidable;
    }

    get portalMaterial() {
        return new THREE.MeshBasicMaterial({
            map: this._world.renderTarget.texture,
        });
    }

    get renderTarget() {
        return this._world.renderTarget;
    }

    get audioData() {
        return this._audioData;
    }

    get world() {
        return this._world;
    }

    get id() {
        return this._id;
    }

    get portalIndex() {
        return this._portalIndex;
    }

    get ws() {
        return this._worldStart;
    }

    get we() {
        return this._worldEnd;
    }

    get name() {
        return this._world.name;
    }

    toString() {
        return `PORTAL | name: ${this._name}, id: ${this._id}, portalIndex: ${this._portalIndex}`;
    }
}